<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '平台'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="140px" :rules="rules">
      <el-form-item label="平台名称" prop="PlatformName">
        <el-input v-model.trim="item.PlatformName" placeholder="请输入平台名称"></el-input>
      </el-form-item>
      <el-form-item label="平台类型" prop="BelongID">
        <select2
          style="width: 100%"
          v-model="item.BelongID"
          url="basic?type=Belong"
          :clearable="false"
          placeholder="请选择平台类型"
          noDataText="无类型"
          :emptyValue="0"
          :currentList="currentBelong"
        ></select2>
      </el-form-item>
      <el-form-item label="业务类型" prop="BusinessTypeID">
        <select2
          style="width: 100%"
          v-model="item.BusinessTypeID"
          url="basic?type=BusinessType"
          :clearable="false"
          placeholder="请选择业务类型"
          noDataText="无类型"
          :emptyValue="0"
          :currentList="currentBusinessType"
        ></select2>
      </el-form-item>
      <el-form-item label="平台级别" prop="PlatformLevelID">
        <select2
          style="width: 100%"
          v-model="item.PlatformLevelID"
          url="basic?type=PlatformLevel"
          :clearable="false"
          placeholder="请选择平台级别"
          noDataText="无级别"
          :emptyValue="0"
          :currentList="currentPlatformLevel"
        ></select2>
      </el-form-item>
      <!-- <el-form-item label="所属客户" prop="ClientID">
        <select2
          style="width: 100%"
          v-model="item.ClientID"
          url="client"
          labelName="ClientName"
          :clearable="false"
          :currentList="currentClient"
          placeholder="请选择客户"
          no-data-text="未找到相关客户"
          :emptyValue="0"
        ></select2>
      </el-form-item>-->
      <el-form-item label="开发单位" prop="DevelopeUnit">
        <el-input v-model.trim="item.DevelopeUnit" placeholder="请输入开发单位"></el-input>
      </el-form-item>
      <!-- <el-form-item label="通讯协议" prop="CommProtocolID">
        <select2
          style="width: 100%"
          v-model="item.CommProtocolID"
          url="basic?type=CommProtocol"
          :clearable="false"
          placeholder="请选择通讯协议"
          noDataText="无通讯协议"
          :emptyValue="0"
          :currentList="currentCommProtocol"
        ></select2>
      </el-form-item>
      <el-form-item label="通讯服务器IP地址" prop="IP">
        <el-input v-model.trim="item.IP" placeholder="请输入通讯服务器IP地址"></el-input>
      </el-form-item>
      <el-form-item label="通讯服务器端口号" prop="Port">
        <el-input v-model.trim="item.Port" placeholder="请输入通讯服务器端口号"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="维护开始时间" prop="MaintainSatrtDay">
        <el-date-picker
          v-model="item.MaintainSatrtDay"
          style="width:100%"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="维护结束时间" prop="MaintainEndDay">
        <el-date-picker
          v-model="item.MaintainEndDay"
          style="width:100%"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>-->
      <el-form-item label="备注" prop="Note">
        <el-input
          v-model.trim="item.Note"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const validateIP = (rule, value, callback) => {
      if (value && !value.match(
        // eslint-disable-next-line max-len
        /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/
      )) {
        callback(new Error('请输入正确的IP地址'));
      } else {
        callback();
      }
    };
    const validatePort = (rule, value, callback) => {
      if (value && !value.match(/^\d{1,5}$/)) {
        callback(new Error('请输入正确的端口号'));
      } else {
        callback();
      }
    };
    return {
      item: {
      },
      rules: {
        PlatformName: [
          { required: true, message: '平台名称不能为空', trigger: 'blur' },
        ],
        BelongID: [
          { required: true, message: '平台类型不能为空', trigger: 'blur' },
        ],
        BusinessTypeID: [
          { required: true, message: '业务类型不能为空', trigger: 'blur' },
        ],
        PlatformLevelID: [
          { required: true, message: '平台级别不能为空', trigger: 'blur' },
        ],
        // ClientID: [
        //   { required: true, message: '客户不能为空', trigger: 'blur' },
        // ],
        DevelopeUnit: [
          { required: true, message: '开发单位不能为空', trigger: 'blur' },
        ],
        CommProtocolID: [
          { required: true, message: '通讯协议不能为空', trigger: 'blur' },
        ],
        IP: [
          { required: true, message: '通讯服务器IP地址不能为空', trigger: 'blur' },
          { validator: validateIP, trigger: 'blur' },
        ],
        Port: [
          { required: true, message: '通讯服务器端口号不能为空', trigger: 'blur' },
          { validator: validatePort, trigger: 'blur' },
        ],
        // MaintainSatrtDay: [
        //   { required: true, message: '维护开始时间不能为空', trigger: 'blur' },
        // ],
        // MaintainEndDay: [
        //   { required: true, message: '维护结束时间不能为空', trigger: 'blur' },
        // ],
      },
      submitting: false,
      currentBelong: [],
      currentClient: [],
      // currentBelongType: [],
      currentBusinessType: [],
      currentPlatformLevel: [],
      // currentCommProtocol: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() { },
  methods: {
    onOpen() {
      // if (this.value.ID) {
      //   if (this.value.ClientID === 0) {
      //     this.current = [{ ID: 0, ClientName: '不限客户' }];
      //   } else if (!this.value.Client) {
      //     this.current = [
      //       { ID: this.value.ClientID, ClientName: '不限客户' },
      //     ];
      //   } else {
      //     this.current = [
      //       {
      //         ID: this.value.ClientID,
      //         ClientName: this.value.Client.ClientName,
      //       },
      //     ];
      //   }
      // } else {
      //   this.current = [{ ID: 0, ClientName: '不限客户' }];
      // }
      this.item = _.clone(this.value);
      if (this.value && this.value.ID) {
        this.currentBelong = [{
          ID: this.value.BelongID,
          Name: this.value.Belong ? this.value.Belong.Name : '',
        }];
        this.currentClient = [{
          ID: this.value.ClientID,
          ClientName: this.value.Client ? this.value.Client.ClientName : '',
        }];
        this.currentBusinessType = [{
          ID: this.value.BusinessTypeID,
          Name: this.value.BusinessType ? this.value.BusinessType.Name : '',
        }];
        this.currentPlatformLevel = [{
          ID: this.value.PlatformLevelID,
          Name: this.value.PlatformLevel ? this.value.PlatformLevel.Name : '',
        }];
        // this.currentCommProtocol = [{
        //   ID: this.value.CommProtocolID,
        //   Name: this.value.CommProtocol ? this.value.CommProtocol.Name : '',
        // }];
      }
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID ? `platform/${itemData.ID}` : 'platform',
            method: itemData.ID ? 'put' : 'post',
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
            this.submitting = false;
            this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
            this.$emit('form:saved', true);
            this.$emit('update:visible', false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
            this.$emit('form:saved', false);
          });
      });
    },
  },
};
</script>
